import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Modal from "react-bootstrap/Modal";
import React from "react";
import Tabs from "views/common/tabs";
import VehicleRegisterDetailViewModel from "viewModels/callCenter/search/vehicleRegister/vehicleRegisterDetail/vehicleRegisterDetailViewModel";
import Button from "@edaz/edazkit/Button";

export const VehicleRegisterDetailView: ViewComponent<VehicleRegisterDetailViewModel> = observer(({ vm }) => {
  return (
    <Modal show={true} onHide={vm.onClose} dialogClassName="modal-75w modal-100h" centered scrollable>
      <Modal.Header className="d-flex justify-content-center mb-3">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <Modal.Title>{vm.name}</Modal.Title>
          <span style={{ fontSize: "1.125rem" }}>{vm.licensePlate}</span>
        </div>
        {vm.allowToSync() && (
          <Button
            style={{ minWidth: "11.5rem", position: "absolute", top: "2.7rem", right: "8rem" }}
            className="mx-3"
            type="reset"
            onClick={vm.onVehicleSynchronization}
            variant="primary">
            {vm.translate("syncBtn")}
          </Button>
        )}
        <button
          onClick={vm.onClose}
          type="button"
          className="close"
          style={{ position: "absolute", top: "2.5rem", right: "2.5rem" }}>
          <span aria-hidden="true">×</span>
          <span className="sr-only">Close</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Tabs vm={vm} />
      </Modal.Body>
    </Modal>
  );
});

registerView(VehicleRegisterDetailView, VehicleRegisterDetailViewModel);
